import r from"styled-components";import{theme as i}from"../../../theme.js";const o=r.div`
  box-shadow: ${i.boxShadow};
  border-radius: ${i.radius}px;
  display: grid;
  grid-template-columns: 136px 1px 1fr;
  .padding {
    padding: ${i.spacing*6}px;
  }
`,a=r.div`
  display: grid;
  grid-template-columns: 1fr 300px;
  grid-column-gap: ${i.spacing*4}px;
  .distance {
    font-size: 14px;
    color: ${i.colors.gray[400]};
    font-weight: 700;
    margin-left: ${i.spacing*8}px;
  }
  > div {
    display: flex;
    flex-direction: column;
    gap: ${i.spacing*2}px;
  }
  @media screen and (max-width: ${i.breakpoints.lg}) {
    grid-template-columns: 1fr;
    grid-row-gap: ${i.spacing*4}px;
  }
`,e=r.div`
  max-height: 100%;
  background-color: ${i.colors.gray[300]};
  width: 1px;
`,n=r.div`
  display: flex;
  flex-direction: column;
  gap: ${i.spacing*2}px;
  align-items: center;
  .rating {
    font-size: 12px;
    color: ${i.colors.gray[900]};
    line-height: 14px;
    display: block;
    text-align: center;
  }
`,t=r.div`
  display: grid;
  grid-template-columns: 24px 1fr;
  grid-column-gap: ${i.spacing*2}px;
  align-items: center;
  font-size: 14px;
  color: ${i.colors.gray[900]};
  font-weight: 700;
  > svg {
    width: 24px;
    height: 24px;
    > g, path {
      fill: ${i.colors.gray[400]};
    }
  }
`,p=r.h3`
  font-size: 20px;
  line-height: 30px;
  font-weight: 700;
  color: ${i.colors.gray[900]};
  margin: 0;
`;export{t as ContactContainer,o as Container,p as DisplayName,e as Divider,n as UserAvatarContainer,a as UserDetailsContainer};
